/*
 * Quick View — infinite scroll re-init
 * The QuickView & Modal (Fast) app runs quickViewApp.detectProductCards() once on
 * page load. The Sezerium theme's infinite scroll appends new product cards after
 * load, which never receive a Quick View button. This watches the product grid and
 * re-runs the app's own detection for newly added cards. The app marks processed
 * cards with data-quickview-btn-bound, so re-running is idempotent (no duplicates).
 */
(function () {
  function rescanQuickView() {
    if (window.quickViewApp && typeof window.quickViewApp.detectProductCards === 'function') {
      window.quickViewApp.detectProductCards();
    }
  }

  function watchGrid() {
    var grids = document.querySelectorAll('ul.product-grid');
    if (!grids.length) return;

    var pending = null;
    var observer = new MutationObserver(function (mutations) {
      var cardAdded = mutations.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (n) {
          return n.nodeType === 1 && (n.matches('li.grid__item') || n.querySelector('product-card'));
        });
      });
      if (!cardAdded) return;
      clearTimeout(pending);
      pending = setTimeout(rescanQuickView, 150);
    });

    grids.forEach(function (grid) {
      observer.observe(grid, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchGrid);
  } else {
    watchGrid();
  }
})();
